import { siteMetadata as siteConfig } from '../../gatsby-config';

const paths = {};

function preloadPaths(pages) {
    pages
        .filter((p) => !!p.path)
        .forEach((page) => {
            paths[page.path] = {
                path: page.path,
                title: page.title,
                internal: true,
                isNew: page.isNew,
            };
        });
}

export const generateNavStructure = (section = 'guide', markdownPages) => {
    preloadPaths(markdownPages);

    const subsections = siteConfig.subsections.filter((subsection) => {
        return subsection.section === section;
    });

    return subsections.map((subsection) => {
        const { name, pages } = subsection;

        return {
            title: name,
            pages: pages.map((path) => {
                if (path.startsWith('/')) {
                    return paths[path];
                }

                const [title, ...rest] = path.split('__');
                return {
                    path: rest.join(''),
                    title,
                    internal: rest.join('').startsWith('/'),
                };
            }),
        };
    });
};

export const SITE_ROOT =
    process.env.GATSBY_SITE_URL || (process.env.NODE_ENV === 'production' ? 'https://docs.smooch.io' : '');
